import {api} from "./_ApiFactoryWithHeader";

export const apiLanguages = {
    getLanguages: (params, cancelToken) => {
        return api.get('languages', params, null, cancelToken)
    },
};